import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

export const DraggableItem = ({ id, content, type,index, moveCard }) => {
    const ref = useRef(null)
    const [{ handlerId }, drop] = useDrop({
        accept: type,
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item) {
            if (!ref.current) {
                return
            }
            const dragIndex = item.index
            const hoverIndex = index
            if (dragIndex === hoverIndex) {
                return
            }
            moveCard(dragIndex, hoverIndex)
            item.index = hoverIndex
        },
    })
    const [{ isDragging }, drag] = useDrag({
        type: type,
        item: () => {
            return { id, index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    drag(drop(ref))
    const opacity = isDragging ? 0 : 1;
    const cursorStyle = isDragging ? 'grabbing' : 'grab';


    return (
        <div
            ref={ref}
            style={{ opacity, cursor: cursorStyle }}
            data-handler-id={handlerId}            
        >
            {content}
        </div>
    );
};
